<!-- showColumn -->
<template>
  <div class="showArticleCover">
    <el-form :model="ruleForm" label-width="160px">
      <el-form-item label="是否显示论文图片：" prop="showArticleCover" class="fl">
        <el-radio-group v-model="ruleForm.showArticleCover">
          <el-radio :label="1">是</el-radio>
          <el-radio :label="0">否</el-radio>
        </el-radio-group>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  name: 'showArticleCover',
  data() {
    return {}
  },
  props: {
    ruleForm: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  components: {},
  computed: {},
  mounted() {},
  methods: {}
}
</script>

<style lang="scss" scoped>
</style>
